module.exports = __webpack_public_path__ + "static/media/review3_guide.63bcc3f4.png";